/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { TableCellProps } from "@material-ui/core/TableCell";
import Tooltip, { TooltipProps } from "@material-ui/core/Tooltip";
import TableSortLabel, {
    TableSortLabelProps
} from "@material-ui/core/TableSortLabel";
import { ColumnSort, getToggledSortDirection } from "../../types";
import { Theme, createStyles, StandardProps } from "@material-ui/core";
import { StyleClassKey } from "js/react/typescript";
import { makeStyles } from "@material-ui/styles";

const styles = (theme: Theme) =>
    createStyles({
        sortLabel: {
            "&:focus": {
                color: theme.palette.grey["600"]
            },
            "& svg": {
                display: "none"
            }
        },
        cellActive: {
            color: theme.palette.grey["600"] + " !important",
            "& svg": {
                display: "inline-block",
                color: theme.palette.grey["600"] + " !important"
            }
        }
    });

type SortTableClassKey = StyleClassKey<typeof styles>;

export interface SortableCellProps extends StandardProps<{}, SortTableClassKey> {
    isNumeric?: boolean;
    sortLabelProps?: TableSortLabelProps;
    tooltipProps?: TooltipProps;
    sort: ColumnSort;
    onSortChanged: (sort: ColumnSort) => void;
}

const useStyles = makeStyles(styles);

export function sortableTableCell<T extends TableCellProps>(
    Component: React.ComponentType<T>
) {
    

    type HOCProps = OwnProps;
    type OwnProps = SortableCellProps & T; //Props that are allowed to passed from Resulting component returned from HOC.

    function SortableTableCell(props: HOCProps) {
        const {
            isNumeric = false,
            tooltipProps,
            sortLabelProps,
            sort,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onSortChanged = () => {},
            ...rest
        } = props;
        const { children, ...cellProps } = rest;
        const tsBypass: T = cellProps as any;
        const classes = useStyles(props);
        return (
            <Component
                {...tsBypass}
                sortDirection={sort.dir ? sort.dir : false}
            >
                <Tooltip
                    title="Sort"
                    placement={isNumeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                >
                    <TableSortLabel
                        active={!!sort.dir}
                        direction={sort.dir ? sort.dir : "asc"}
                        onClick={() =>
                            onSortChanged({
                                ...sort,
                                dir: getToggledSortDirection(sort.dir)
                            })
                        }
                        classes={{
                            active: classes.cellActive,
                            root: classes.sortLabel
                        }}
                    >
                        {children}
                    </TableSortLabel>
                </Tooltip>
            </Component>
        );
    }

    return SortableTableCell;
}

export default sortableTableCell;
